import { Injectable, OnDestroy } from '@angular/core'

import {
  Observable,
  BehaviorSubject,
  Subscription,
  fromEvent,
  merge,
  of
} from 'rxjs'
import { mapTo } from 'rxjs/operators'
import { environment } from '@env/environment'
/**
 * Class responsible to provide the online status of the application
 */
@Injectable({
  providedIn: 'root'
})
export class NetworkService implements OnDestroy {
  private connectionSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false)

  private connectionDisposable: Subscription

  /**
   * Get an Observable of the application network status.<br/>
   * <b>true</b> => online <br/>
   * <b>false</b> => offline
   */
  public connection: Observable<boolean>

  /**
   * Get the current status of the network.<br/>
   * <b>true</b> => online <br/>
   * <b>false</b> => offline
   */
  public get connected(): boolean {
    return this.connectionSubject.getValue()
  }

  constructor() {
    this.connection = this.connectionSubject.asObservable()

    this.connectionDisposable = merge(
      of(navigator.onLine),
      fromEvent(window, 'online').pipe(mapTo(true)),
      fromEvent(window, 'offline').pipe(mapTo(false))
    ).subscribe((cConnected: boolean) => {
      this.connectionSubject.next(cConnected)
    })
  }

  /**
   * When the service is destroyed we unsubscribe from the observable to prevent memory leak
   */
  ngOnDestroy() {
    if (this.connectionDisposable) {
      this.connectionDisposable.unsubscribe()
    }
  }

  public endpoint(url: string): string {
    return `${environment.apiUrl}${url}`
  }
}
